/**
 * Laravel signs URLs by alphabetizing (ksort) the parameters before hashing, but never re-sorts
 * on validation — it hashes whatever query string order the request actually arrives in. Axios
 * preserves object key insertion order when serializing GET params, so a signed link's params
 * must be rebuilt here in alphabetical key order or the signature check fails with 403.
 */
export const sortSignedUrlParams = <T extends object>(params: T): T => {
    const sorted = {} as T;
    for (const key of Object.keys(params).sort() as Array<keyof T>) {
        sorted[key] = params[key];
    }
    return sorted;
};
